import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n";

const LanguageContext = createContext(null);

const STORAGE_KEY = "yc_lang";
const VALID = ["de", "ku"];

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    if (typeof window === "undefined") return "de";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return VALID.includes(saved) ? saved : "de";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, language);
      document.documentElement.setAttribute("lang", language);
    } catch (_) {
      /* localStorage unavailable */
    }
  }, [language]);

  const setLanguage = (lang) => {
    if (VALID.includes(lang)) setLanguageState(lang);
  };

  const value = {
    language,
    setLanguage,
    t: translations[language],
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return ctx;
};
